import _ from 'lodash';
import moment from 'moment';
import createUuid from 'uuid/v4';

import { buildTypes } from 'utils/reducer-utils';
import Timer from 'services/data/timer';
import replaceById from 'utils/replace-by-id';
import store from 'app-store';

const { SET } = buildTypes('timers');

// Action creators
export function set(data) {
  if (data.timers) {
    const timers = _(data.timers)
      .reject({ status: 'Converted' })
      .map(timer => ({
        ...timer,
        timerIntervals: _.orderBy(timer.timerIntervals, ['start'], ['desc'])
      }))
      .orderBy(['timerIntervals[0].start', 'createdAt'], ['desc', 'desc'])
      .value();

    data.timers = timers;
  }

  store.dispatch({
    type: SET,
    data
  });
}

export function update(timer, options = {}) {
  const timers = store.getState().timers.timers;
  const thisTimer = _.find(timers, { uuid: timer.uuid });

  // Never take the description from the socket, as it could be behind
  if (options.fromSocket && thisTimer && document.hasFocus()) timer.description = thisTimer.description;

  set({ timers: replaceById(timer, timers) });

  if (!options.skipUpdate) {
    const method = timer.id ? Timer.update : Timer.create;
    method.bind(Timer)({
      ...timer,
      ticket: _.get(timer, 'ticket.id', timer.ticket),
      company: _.get(timer, 'company.id', timer.company)
    });
  }
}

export function add(ticket) {
  const timer = {
    description: '[new timer]',
    uuid: createUuid(),
    status: 'Active',
    timerIntervals: []
  };

  if (ticket) {
    timer.ticket = ticket;
    timer.description = `From ticket: ${ticket.description}`;
  }

  if (ticket && ticket.company) timer.company = ticket.company;

  start(timer);
}

export function start(timer, options) {
  const timers = store.getState().timers.timers;
  const activeTimer = _.find(timers, Timer.isActive);
  if (activeTimer) stop(activeTimer, { skipUpdate: true });
  
  const newInterval = { start: moment().toDate() };
  update({
    uuid: createUuid(),
    ...timer,
    timerIntervals: _.concat(timer.timerIntervals, newInterval),
    updatedAt: moment().toDate()
  }, options);
}

export function stop(timer, options) {
  if (!Timer.isActive(timer)) return update(timer, options);

  const interval = _.find(timer.timerIntervals, testInterval => !testInterval.end);
  const updatedInterval = { ...interval, end: moment().toDate() };

  update({ ...timer, timerIntervals: replaceById(updatedInterval, timer.timerIntervals) }, options);
}

export function updateInterval(timer, interval) {
  update({ ...timer, timerIntervals: replaceById(interval, timer.timerIntervals) });
}

export function archive(timer) {
  stop({ ...timer, status: 'Archived' });
}

export function restore(timer) {
  stop({ ...timer, status: 'Active' });
}
